import { useEffect } from 'react';

export default function CommandeScolaire() {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div data-testid="commande-scolaire-page" className="fixed inset-0 z-[9999]">
      <iframe
        src="https://parent.conceptgourmet.portailrepas.ca"
        title="Commande Scolaire"
        className="w-full h-full border-0"
        allow="payment; clipboard-write; camera; microphone"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
      />
    </div>
  );
}
